var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Remove",
    clipPath: "url(#clip0_457_1062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.88627 6.11442L6.11503 9.88566M9.88627 9.88566L6.11503 6.11442M12.0007 1.33337H4.00065C2.52789 1.33337 1.33398 2.52728 1.33398 4.00004V12C1.33398 13.4728 2.52789 14.6667 4.00065 14.6667H12.0007C13.4734 14.6667 14.6673 13.4728 14.6673 12V4.00004C14.6673 2.52728 13.4734 1.33337 12.0007 1.33337Z",
    stroke: "#1E2D66",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_1062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.2e11d508c405d09ff47567049b983807.svg";
export { ForwardRef as ReactComponent };